import Seo from "../components/Seo";
import { useI18n } from "../i18n/LanguageProvider";
import { useRegisterAlternates } from "../components/layout/Layout";
import { pagePath } from "../config/pages";
import { FAQS } from "../data/faqs";
import { PageHero, CTABand } from "../components/Sections";
import { Reveal } from "../components/motion/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { webPageSchema, breadcrumbSchema, faqSchema } from "../lib/schema";

const META = {
  title: {
    en: "Dental Treatment in Vietnam FAQ | Dentel Vietnam",
    fr: "FAQ soins dentaires au Vietnam | Dentel Vietnam",
    de: "FAQ Zahnbehandlung in Vietnam | Dentel Vietnam",
  },
  desc: {
    en: "Answers to the most common questions about dental treatment in Vietnam for international patients — safety, costs, timelines and more.",
    fr: "Réponses aux questions les plus fréquentes sur les soins dentaires au Vietnam pour les patients internationaux — sécurité, coûts, délais et plus.",
    de: "Antworten auf die häufigsten Fragen zur Zahnbehandlung in Vietnam — Sicherheit, Kosten, Zeitpläne und mehr.",
  },
};

export default function Faq() {
  const { t, lang, p } = useI18n();
  const alternates = { en: pagePath("faq", "en"), fr: pagePath("faq", "fr"), de: pagePath("faq", "de") };
  useRegisterAlternates(alternates);
  const path = pagePath("faq", lang);
  const list = FAQS.map((q) => ({ q: q.q[lang] || q.q.en, a: q.a[lang] || q.a.en }));

  return (
    <>
      <Seo
        title={META.title[lang] || META.title.en}
        description={META.desc[lang] || META.desc.en}
        path={path}
        alternates={alternates}
        lang={lang}
        jsonLd={[
          webPageSchema({ name: t.faqSection.title, description: META.desc[lang] || META.desc.en, path }),
          breadcrumbSchema([{ name: t.common.home, path: p("home") }, { name: t.nav.faq, path }]),
          faqSchema(list),
        ]}
      />
      <PageHero eyebrow={t.faqSection.eyebrow} title={t.faqSection.title} intro={t.faqSection.sub} crumbs={[{ name: t.nav.faq, to: path }]} />

      <section className="container-dv py-16 lg:py-20 max-w-3xl">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-page-accordion">
            {list.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="rounded-2xl border border-navy/10 bg-white px-5 shadow-soft data-[state=open]:border-dental/30">
                <AccordionTrigger data-testid={`faq-page-trigger-${i}`} className="py-5 text-left text-base font-semibold text-navy hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-[15px] leading-relaxed text-navy/70">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>

      <CTABand />
    </>
  );
}
